<template>
  <Modal
    :is-open="isOpen"
    size="md"
    :close-on-backdrop="closeOnBackdrop"
    :show-close-button="showCloseButton"
    container-class="max-w-md"
    @close="handleClose"
    :scrollable="false"
  >
    <div
      class="flex flex-col items-center justify-center"
      style="height: 16rem;"
    >
      <div
        :class="[
          'w-16 h-16 rounded-full flex items-center justify-center mb-4',
          errorType === 'invalid_table' ? 'bg-red-50' : 'bg-yellow-50'
        ]"
      >
        <AlertCircle
          :size="40"
          :class="
            errorType === 'invalid_table' ? 'text-red-600' : 'text-yellow-600'
          "
        />
      </div>

      <h4 class="text-2xl font-serif font-bold text-gray-900 mb-2 text-center">
        {{ modalTitle }}
      </h4>

      <p class="text-gray-600 text-center text-sm mb-6" v-html="mainMessage" />

      <div
        v-if="workingHours && errorType !== 'invalid_table'"
        class="w-full mt-4 pt-4 border-t border-gray-100"
      >
        <p class="text-base font-medium text-gray-900 text-center">
          {{ workingHours }}
        </p>
      </div>

      <div v-if="errorType === 'store_closed'" class="w-full mt-6 space-y-3">
        <button
          @click="handleClose"
          class="w-full bg-primary-600 text-white font-bold py-3 rounded-xl shadow-lg shadow-primary-600/20 hover:bg-primary-700 transition-all active:scale-[0.98]"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "../ui/Modal.vue";
import { AlertCircle } from "lucide-vue";

export default {
  name: "TableStoreClosedModal",
  components: {
    Modal,
    AlertCircle
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    workingHours: {
      type: String,
      default: null
    },
    errorType: {
      type: String,
      default: "store_closed", // 'store_closed' | 'invalid_table'
      validator: (value) => ["store_closed", "invalid_table"].includes(value)
    },
    errorMessage: {
      type: String,
      default: null
    }
  },
  computed: {
    closeOnBackdrop() {
      // For invalid table, don't allow closing on backdrop
      return false;
    },
    showCloseButton() {
      // For invalid table, don't show close button
      return false;
    },
    modalTitle() {
      if (this.errorType === "invalid_table") {
        return "Invalid Table Code";
      }
      return "Store Currently Closed";
    },
    mainMessage() {
      if (this.errorType === "invalid_table") {
        const customMessage =
          this.errorMessage ||
          "Please scan a valid QR code to place your order.";
        return customMessage;
      }
      return "The store is <b>currently closed</b>. You can browse the menu, but you won't be able to place orders at this time.";
    },
    buttonText() {
      if (this.errorType === "invalid_table") {
        return "Browse Menu";
      }
      return "Browse Menu";
    }
  },
  methods: {
    handleClose() {}
  }
};
</script>
